import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__confirm-link-btn';
export class ConfirmLinkModal {
    static init($root = $('body')) {
        const $element = $root.find(ELEMENT_SELECTOR);
        if (!$element.length) {
            return;
        }
        this.initActions($element);
    }
    static initActions($element) {
        $element.on('click', e => {
            e.preventDefault();
            const target = e.currentTarget;
            const $target = $(target);
            let selector = target.getAttribute('data-target');
            if (!selector || selector === '#') {
                selector = '.js__confirm-link-modal';
            }
            const $modal = $(selector);
            if (!$modal.is('.ui.modal')) {
                window.console.warn('Confirm link button target expected to be modal');
                return;
            }
            $modal
                .modal({
                autofocus: false,
                closable: false,
                onApprove: function () {
                    if ($target.data('collection-delete-with-confirmation')) {
                        $target.attr('data-form-collection', 'delete');
                        // @ts-ignore
                        $target.attr('data-collection-delete-with-confirmation', false);
                        $target.trigger('click');
                    }
                    else {
                        window.location.replace($target.attr('href') || '');
                    }
                },
            })
                .modal('show');
        });
    }
}
